import { render, staticRenderFns } from "./DonutChart72.vue?vue&type=template&id=441ba0d2&scoped=true&"
import script from "./DonutChart72.vue?vue&type=script&lang=js&"
export * from "./DonutChart72.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441ba0d2",
  null
  
)

export default component.exports